<template>
  <div>
    <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item"><router-link to="/">{{ $t("home") }}</router-link></li>
        <li class="Breadcrumb__item"><span>{{ $t("termsAndConditions") }}</span></li>
      </ul>
    </div>

    <div class="PageHeader">
      <h1 class="PageHeader__heading">{{ $t("termsAndConditions") }}</h1>
    </div>
    <div class="HeroImage">
      <div class="HeroImage__content">
        <h2 class="HeroImage__content__heading">{{ $t("selectProduct") }}</h2>
        <div class="Selection">
          <router-link class="Selection__item" to="/terms-and-conditions/imagic"><span v-html="$t('imagic')"></span></router-link>
          <router-link class="Selection__item" to="/terms-and-conditions/day-digipass"><span>{{ $t("dayDigipass") }}</span></router-link>
          <router-link class="Selection__item" to="/terms-and-conditions/season-digipass"><span>{{ $t("seasonDigipass") }}</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import './../../styles/_variables';

  .HeroImage {
    height: 26em;
    margin-bottom: 5em;
    background: url('./../../assets/bg/stadium.jpg');
    background-size: cover;
    @media (max-width: 405px) {
      height: 30em;
    }

    @media (min-width: $tabletSmall) {
      height: 26.875em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TermsAndConditions/TermsAndConditions.vue